import React, { useMemo } from 'react';
import { useAuthStore } from '../../../store';
import UserMenuView, { getLoggedInLinks } from './user-menu-view';
import { UserMenuContainerProps } from '../types';

/**
 * Wires UserMenuView to auth context (replaces Redux connect).
 * Travel app is traveler-only; logged-in links use relative paths.
 */
function UserMenuContainer({ onClickLink }: UserMenuContainerProps) {
  const { isAuthenticated } = useAuthStore();
  const loggedInLinks = useMemo(() => getLoggedInLinks(), []);

  return (
    <UserMenuView
      loggedIn={isAuthenticated === true}
      loggedInLinks={loggedInLinks}
      onClickLink={onClickLink}
    />
  );
}

export default UserMenuContainer;
